import { render, staticRenderFns } from "./Atestados.vue?vue&type=template&id=b503192c&scoped=true"
import script from "./Atestados.vue?vue&type=script&lang=js"
export * from "./Atestados.vue?vue&type=script&lang=js"
import style0 from "./Atestados.vue?vue&type=style&index=0&id=b503192c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b503192c",
  null
  
)

export default component.exports